export default class Form {
    static init(): void {
        Form.validation();

    }

    static validation(): void {
        const formsToValidate: NodeListOf<HTMLFormElement> = document.querySelectorAll('[data-validation]');
        if (formsToValidate.length > 0) {
            formsToValidate.forEach((form) => {
                if (form.dataset.validation === 'onLoad') {
                    Form.validateForm(form);
                }

                const requiredControls: NodeListOf<HTMLInputElement> = form.querySelectorAll('[data-required],[data-notrequired]');
                requiredControls.forEach((control) => {
                    Form.listenControl(control);
                });

                const requiredSelectboxes: NodeListOf<HTMLInputElement> =
                    form.querySelectorAll('[data-requiredSelectbox]');

                requiredSelectboxes.forEach((selectbox: HTMLInputElement) => {
                    if (selectbox.dataset.requiredselectbox) {
                        const dropdown = document.getElementById(selectbox.dataset.requiredselectbox);
                        if (dropdown) {
                            const options = dropdown.querySelectorAll('.box-dropdown__option');

                            options.forEach((option) => {
                                option.addEventListener('click', () => {
                                    if (selectbox.parentElement) {
                                        setTimeout(function () {
                                            const container = selectbox.parentElement;
                                            if (container) {
                                                if (selectbox.value) {
                                                    container.classList.remove('form-control--error');
                                                } else {
                                                    container.classList.add('form-control--error');
                                                }
                                            }
                                        }, 100);
                                    }
                                });
                            });
                        }
                    }
                });

                const formSubmit = form?.querySelector('button[type="submit"]') as HTMLButtonElement;
                formSubmit.addEventListener('click', function (e) {
                    e.preventDefault();

                    Form.validateForm(form);

                    const errors = form.querySelectorAll('.form-control--error');
                    console.log('errors', errors.length);
                    if (errors.length === 0) {
                        const loader = document.querySelector('.loader');
                        if (loader) {
                            loader.classList.add('loader--visible');
                        }
                        form.submit();
                    } else {
                        const firstError = errors[0] as HTMLElement;
                        firstError.focus();
                    }
                });
            });
        }
    }

    static validateForm(form: HTMLFormElement): void {
        const requiredControls: NodeListOf<HTMLInputElement> = form.querySelectorAll('[data-required]');

        if (requiredControls.length > 0) {
            requiredControls.forEach((control) => {
                Form.validateControl(control);
            });
        }
    }

    static validateControl(control: HTMLInputElement): void {
        const isEmail = control.dataset.required === 'email';
        const isSelect = control.dataset.required === 'select';
        const isCheckbox = control.type === 'checkbox';
        const isMultiCheckbox = control.dataset.required === 'multiCheckbox';
        const isRadio = control.dataset.required === 'radio-parent';
        const isNumChar = control.dataset.required === 'numLetter';
        const isPostCode = control.dataset.required === 'postCode';
        const isTel = control.dataset.required === 'tel';
        const isTwoWords = control.dataset.required === '2words';
        const notRequiredContractNumber = control.dataset.notrequired === 'contractNumber';

        if (isCheckbox) {
            if (control.checked) {
                control.classList.remove('form-control--error');
                control.classList.add('form-container--success');
            } else {
                control.classList.add('form-control--error');
                control.classList.remove('form-container--success');
            }
        } else if (isMultiCheckbox) {
            const checkboxes = control.querySelectorAll('input[type="checkbox"]') as NodeListOf<HTMLInputElement>;
            if (checkboxes.length > 0) {
                let checked = false;
                checkboxes.forEach((checkbox) => {
                    if (checkbox.checked) {
                        checked = true;
                    }
                });
                checkboxes.forEach((checkbox) => {
                    if (checked) {
                        checkbox.classList.remove('form-control--error');
                        checkbox.classList.add('form-container--success');
                    } else {
                        checkbox.classList.add('form-control--error');
                        checkbox.classList.remove('form-container--success');
                    }
                });
            }
        } else if (isRadio) {
            const radios = control.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;
            if (radios.length > 0) {
                let checked = false;
                radios.forEach((radio) => {
                    if (radio.checked) {
                        checked = true;
                    }
                });
                radios.forEach((radio) => {
                    if (checked) {
                        radio.classList.remove('form-control--error');
                        radio.classList.add('form-container--success');
                        const parentContainer = radio.closest('.form-checkbox__container');
                        if (parentContainer) {
                            parentContainer.classList.remove('is-error');
                        }
                    } else {
                        radio.classList.add('form-control--error');
                        radio.classList.remove('form-container--success');
                        const parentContainer = radio.closest('.form-checkbox__container');
                        if (parentContainer) {
                            parentContainer.classList.add('is-error');
                        }
                    }
                });
            }
        } else if (notRequiredContractNumber) {
            if (control.value === '') {
                control.classList.remove('form-control--error');
                control.classList.add('form-container--success');
            } else if (/^OP-[0-9]{2}-[0-9]{5}$/g.test(control.value)) {
                control.classList.remove('form-control--error');
                control.classList.add('form-container--success');
            } else {
                control.classList.add('form-control--error');
                control.classList.remove('form-container--success');
            }
        } else if (control.value === '') {
            control.classList.add('form-control--error');
            control.classList.remove('form-container--success');
            if (control.tagName === 'TEXTAREA') {
                const uploadParent = control.closest('.upload-input--has-textarea');
                if (uploadParent) {
                    uploadParent.classList.add('form-control--error');
                }
            }
        } else if (isEmail) {
            if (this.validateEmail(control.value)) {
                control.classList.remove('form-control--error');
                control.classList.add('form-container--success');
            } else {
                control.classList.add('form-control--error');
                control.classList.remove('form-container--success');
            }
        } else if (isNumChar) {
            if (/(?=.*?[0-9])(?=.*?[A-Za-z])(?=.*[^0-9A-Za-z]).+/g.test(control.value)) {
                control.classList.remove('form-control--error');
                control.classList.add('form-container--success');
            } else {
                control.classList.add('form-control--error');
                control.classList.remove('form-container--success');
            }
        } else if (isPostCode) {
            control.value = control.value.replace(/[^0-9.]/g, '');
            control.value = control.value.replace(/(\..*)\./g, '$1');
            if (control.value.length === 5) {
                control.classList.remove('form-control--error');
                control.classList.add('form-container--success');
            } else {
                control.classList.add('form-control--error');
                control.classList.remove('form-container--success');
            }
        } else if (isTel) {
            control.value = this.getPhone(control.value);
            if (this.validatePhone(control.value)) {
                control.classList.remove('form-control--error');
                control.classList.add('form-container--success');
            } else {
                control.classList.add('form-control--error');
                control.classList.remove('form-container--success');
            }
        } else if (isSelect) {
            if (control.value !== '') {
                control.classList.remove('form-control--error');
                control.classList.add('form-container--success');
            }
        } else if (isTwoWords) {
            const words = control.value.split(' ');
            if (words.length === 2 && words[0].length > 0 && words[1].length > 0) {
                control.classList.remove('form-control--error');
                control.classList.add('form-container--success');
            } else {
                control.classList.add('form-control--error');
                control.classList.remove('form-container--success');
            }
        } else {
            control.classList.remove('form-control--error');
            control.classList.add('form-container--success');

            if (control.tagName === 'TEXTAREA') {
                const uploadParent = control.closest('.upload-input--has-textarea');
                if (uploadParent) {
                    uploadParent.classList.remove('form-control--error');
                }
            }
        }
    }

    static listenControl(control: HTMLInputElement): void {
        const onlyLetters = control.dataset.required === 'onlyLetters';

        if (control.value && !control.hasAttribute('not-validate-on-load')) {
            Form.validateControl(control);
        }

        control.addEventListener('input', () => {
            Form.validateControl(control);

            if (onlyLetters) {
                if (!/^[a-zA-Zá-ž ]+$/.test(control.value)) {
                    control.value = control.value.slice(0, -1);
                }
            }
        });
    }

    static validateEmail(email: string): boolean {
        // min 2 znaky po poslední tečce
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    static getPhone(phone: string): string {
        phone = phone.replace(/\s/g, '');
        phone = phone.replace(/[^0-9+]/g, '');

        if (phone.startsWith('00')) {
            phone = phone.replace('00', '+');
        }

        let phonePrefix = '';
        if (phone.startsWith('+420') || phone.startsWith('+421') || phone.startsWith('+380')) {
            phonePrefix = phone.substring(0, 4);
            phone = phone.substring(4);
        } else if (phone.startsWith('+43') || phone.startsWith('+48') || phone.startsWith('+49') || phone.startsWith('+84')) {
            phonePrefix = phone.substring(0, 3);
            phone = phone.substring(3);
        }

        if (phone.length > 0) {
            phonePrefix += ' ';
        }

        return phonePrefix + phone;
    }

    static validatePhone(phone: string): boolean {
        let result = false;

        if (phone.startsWith('+420')) {
            result = /^(\+420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/g.test(phone);
        } else if (phone.startsWith('+421')) {
            result = /^(\+421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/g.test(phone);
        } else if (phone.startsWith('+380')) {
            result = /^(\+380)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/g.test(phone);
        } else if (phone.startsWith('+48')) {
            result = /^(\+48)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/g.test(phone);
        } else if (phone.startsWith('+43')) {
            result = /^(\+43)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/g.test(phone);
        } else if (phone.startsWith('+49')) {
            if (phone.length >= 12 && phone.length <= 15) {
                result = true;
            }
        } else if (phone.startsWith('+84')) {
            if (phone.length >= 12 && phone.length <= 15) {
                result = true;
            }
        } else {
            // remove spaces
            phone = phone.replace(/\s/g, '');
            // min 9 numbers without another characters
            if (phone.length >= 9) {
                result = /^[0-9]{9,15}$/g.test(phone);
            }
        }

        return result;
    }
}
